import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Draggable from 'react-draggable';
import { useSelector } from 'react-redux';
import { Row, Col } from 'reactstrap';

import translations from 'services/translations/translations';
import ProjectSelect from '../forms/ProjectSelect';
import TextInputField from '../forms/TextInputField';
import PrimaryButton from '../buttons/PrimaryButton';

import 'style/layout/Forms.css';
import 'style/layout/navbar/SaveNameModal.css';

const SaveConfigurationModal = ({
  showSave,
  setShowSave,
  saveName,
  placeholder,
}: {
  showSave: boolean;
  setShowSave: (close: boolean) => void;
  saveName: (name: string, newProjectId: string) => void;
  placeholder: string;
}): JSX.Element | null => {
  const { t } = useTranslation([translations.common]);
  const [name, setName] = useState('');
  const [project, setProject] = useState<{
    label: string;
    value: string;
  }>();
  const configuration = useSelector((state: any) => state.configuration);

  useEffect(() => {
    if (configuration !== null) {
      setProject({
        label: configuration.project.name,
        value: configuration.project.id,
      });
    }
  }, [configuration]);

  useEffect(() => {
    setName(placeholder);
  }, [placeholder]);

  if (!showSave) {
    return null;
  }

  const handleProject = (
    updatedProject: { label: string; value: string } | null
  ) => {
    const emptyProject = {
      label: '',
      value: '',
    };
    setProject(updatedProject === null ? emptyProject : updatedProject);
  };

  return (
    <Draggable>
      <div className="properties-edit-popup save-name-modal">
        <Row>
          <Col>
            <h2 onClick={() => setShowSave(false)}>&times;</h2>
          </Col>
        </Row>
        <Row>
          <Col>
            <TextInputField
              id="name"
              label={t(`${translations.common}:Name`)}
              onChange={(e: any) => setName(e.target.value)}
              value={name}
              name="name"
              required
              className="edit-fields"
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <ProjectSelect
              label={t(`${translations.common}:Projects`)}
              onChange={handleProject}
              value={project}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <PrimaryButton
              onClick={() =>
                saveName(name, project !== undefined ? project?.value : '')
              }
              className="button-edit-popup add-door-button"
            >
              {t(`${translations.common}:Save as a copy`).toLocaleUpperCase()}
            </PrimaryButton>
          </Col>
          <Col>
            <PrimaryButton
              onClick={() => saveName(name, '')}
              className="button-edit-popup"
            >
              {t(`${translations.common}:Save`).toLocaleUpperCase()}
            </PrimaryButton>
          </Col>
        </Row>
      </div>
    </Draggable>
  );
};

export default SaveConfigurationModal;
